import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import clientFetcherHoc from "@hocs/clientFetcherHoc";
import {Client} from "@models/client";
import {useDispatch, useSelector} from "react-redux";
import {getClientsList, getMainClient, getMainClientId, isFetchedClients} from "./selectors";
import {fetchRequest as fetchClients} from "@actions/client"


const Option = Select.Option;


export interface ClientMultiSelectionReturnValue {
  new_clients: string[];
  deleted_clients: string[];
  selectedItems: Client[]
}

type ClientSelectionProps = {
  mode: SelectionMode,
  onChange: (value: ClientMultiSelectionReturnValue) => void
  selectedClients: Client[],
  data: Client[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: Client[] | Client | null
}


const ClientsSelection: React.FC<ClientSelectionProps> = props => {
  const {initialValue, disabled=false, onChange, mode = SelectionMode.DEFAULT} = props;
  const dispatch = useDispatch()
  const isFetched = useSelector(isFetchedClients);
  const data = useSelector(getClientsList);
  const defaultSelectedClient = useSelector(getMainClient);
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  useEffect(() => {
    if(!isFetched){
      dispatch(fetchClients())
    }
  }, []);
  
  useEffect(() => {
    if(isFetched){
      onChange(defaultSelectedClient)
    }
  }, [isFetched]);
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const selectedValues = props.initialValue || [];
      const oldValue = selectedValues.map(cat => cat.id);
      const deleted_clients = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_clients = newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
      props.onChange({
        deleted_clients,
        new_clients,
        selectedItems: option.map(opt => opt.props.client)
      });
    }
    else {
      onChange(option.props.client)
    }
  };
  
  // TODO:
  return (
    <Select
      showSearch
      mode={mode}
      value={value}
      disabled={disabled}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
    >
      {data.map(item =>
        <Option key={item.id} client={item}>{item.title}</Option>
      )}
    </Select>
  );
};

export default clientFetcherHoc(ClientsSelection);


